namespace TabAurous.OMS {
    export namespace BalanceSheetService {
        export const baseUrl = 'OMS/BalanceSheet';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<LedgerPostingRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "OMS/BalanceSheet/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>BalanceSheetService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
